import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	login: '',
	hash: '',
	agreement: false,
	password: '',
	repeatPassword: '',
};

export const registrationSlice = createSlice({
	name: 'registration',
	initialState,
	reducers: {
		resetState: () => initialState,
		setLogin: (state, action) => {
			const { payload: login = initialState.login } = action;
			state.login = login;
		},
		setHash: (state, action) => {
			const { payload: hash = initialState.hash } = action;
			state.hash = hash;
		},
		setAgreement: (state, action) => {
			const { payload: agreement = initialState.agreement } = action;
			state.agreement = agreement;
		},
		setPassword: (state, action) => {
			const { payload: password = initialState.password } = action;
			state.password = password;
		},
		setRepeatPassword: (state, action) => {
			const { payload: repeatPassword = initialState.repeatPassword } = action;
			state.repeatPassword = repeatPassword;
		},
	},
});
